import { fetchProductSuccess, fetchProductFailure } from "./productsSlice";
import {
  fetchCartSuccess,
  fetchCartFailure,
  fetchDirectCartSuccess,
  syncComposedCartsSuccess,
  setShowCartComposer,
} from "./cartsSlice";
import { addVendorShippingInfo } from "utilities/addShippingInfo";
import { composerSlice } from "./composerSlice";

export default function parseReceivedMessage(
  dispatch,
  lastJsonMessage,
  additionalStoreData = null
) {
  // Check for preview_carts response
  if (
    lastJsonMessage.action === "preview_carts" &&
    additionalStoreData?.composer?.messageId === lastJsonMessage.message_id
  ) {
    if (lastJsonMessage.error) {
      dispatch(composerSlice.actions.previewCartsError(lastJsonMessage.error));
      const composerCartsExist = Object.keys(additionalStoreData?.composer?.composerCarts).length > 0;
      if (!composerCartsExist) {
        // reset to actual cart state if first cart composer attempt fails
        dispatch(setShowCartComposer(false));
      }
    } else {
      dispatch(composerSlice.actions.previewCartsSuccess(lastJsonMessage));
    }
    return true;
  }

  // Check for sync_composed_carts
  if (
    lastJsonMessage.action === "sync_composed_carts" &&
    additionalStoreData?.composer?.messageId === lastJsonMessage.message_id
  ) {
    if (lastJsonMessage.success) {
      dispatch(syncComposedCartsSuccess({ carts: lastJsonMessage.vendor_po_items }));
      dispatch(composerSlice.actions.syncSuccess());
    } else {
      dispatch(
        composerSlice.actions.syncFailure(
          lastJsonMessage.error || "Sync failed"
        )
      );
    }
    return true;
  }

  if (lastJsonMessage.action === "fetch_products") {
    if (lastJsonMessage?.error === true) {
      dispatch(
        fetchProductFailure({
          dgi_style_sku: lastJsonMessage.dgi_style_sku,
          master_color: lastJsonMessage.master_color,
          vendorCode: lastJsonMessage.vendorCode,
          errorCode: lastJsonMessage?.statusCode,
          errorMessage: lastJsonMessage?.errorMessage,
        })
      );
    } else {
      const vendorCode = lastJsonMessage.vendorCode;
      let productData = { ...lastJsonMessage.data };
      productData = addVendorShippingInfo(
        productData,
        vendorCode,
        additionalStoreData?.est_delivery_days
      );
      dispatch(
        fetchProductSuccess({
          dgi_style_sku: lastJsonMessage.dgi_style_sku,
          master_color: lastJsonMessage.master_color,
          vendorCode: vendorCode,
          productData: productData,
          ttl: lastJsonMessage?.ttl,
        })
      );
    }
  } else if (lastJsonMessage.action === "get_carts") {
    const vendorCode = lastJsonMessage.vendorCode;

    // Skip processing message_id and other metadata fields that might be mistaken for vendor codes
    if (
      [
        "message_id",
        "action",
        "error",
        "chunked",
        "total_chunks",
        "total_size",
      ].includes(vendorCode)
    ) {
      console.log("Skipping metadata field in get_carts:", vendorCode);
      return;
    }

    // Handle error case for both direct and regular carts
    if (lastJsonMessage?.error === true) {
      dispatch(
        fetchCartFailure({
          vendorCode: vendorCode || "unknown",
          errorCode: 500,
          errorMessage: lastJsonMessage?.errorMessage,
        })
      );
      return;
    }

    // Handle direct carts (direct response contains multiple vendor carts)
    if (vendorCode === "direct") {
      dispatch(
        fetchDirectCartSuccess({
          directCartData: lastJsonMessage,
        })
      );
      return;
    }

    // Only process valid vendor codes
    if (vendorCode != null) {
      dispatch(
        fetchCartSuccess({
          vendorCode: vendorCode,
          cartData: lastJsonMessage,
        })
      );
    }
  }
  return;
}
